import React from 'react';
import '../styles/Loading.scss';
import iconLoad from '../assets/icons/icon_load.png';
const Loading = () => {
  return (
    <div className="loading-overlay">
      <div className="loading-container">
        <img src={iconLoad} alt="Loading" className="loading-icon" />
        <p>Loading...</p>
      </div>
    </div>
  );
};
export default Loading;